import React, { JSX } from 'react';
import {
    List,
    TextField,
    ReferenceField,
    TopToolbar,
    CreateButton,
    Datagrid,
    EditButton,
    BooleanField,
    NumberField,
    SelectField
} from 'react-admin';
import { currency } from "../../defaults/defaults";


const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            {/* No gate here on purpose: react-admin asks `authProvider.canAccess` for this button
                itself, and the map there names the verb. A check beside it would be the same
                rule written twice. */}
                <CreateButton />
        </TopToolbar>
    );
}


export const SubscriptionProductPriceList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions/> }
        >
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <TextField source="name"  />
                <BooleanField source="active" />
                <BooleanField source="liveMode" />
                <TextField source="priceFrequency" sx={ { textTransform: 'capitalize' } } />
                <SelectField source="currency" choices={ currency } />
                <NumberField source="price" label="Price" />
                <ReferenceField source="subscriptionProduct" reference="subscription_products" label="Subscription Product" />
                <EditButton />

            </Datagrid>
        </List>
    );
}
